export const EXTENSION_TYPE_NAME = 'da-mention';

//# sourceMappingURL=constants.js.map